export default function ServicesHero() {
  return (
    <section className="relative bg-[#1A1A1A] pt-52 pb-24">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Our Services
        </h1>
        <p className="text-xl md:text-2xl text-[#C5A55A] max-w-3xl mx-auto">
          Full-Service Construction. Trusted Results.
        </p>
      </div>
    </section>
  );
}